import React, { useCallback } from 'react';

const DisposalForm = ({
  disposalQuestions = [],
  disposalData,
  onChange,
  onSubmit,
  onBack,
  pushToDataLayer,
}) => {
  const handleChange = useCallback(
    (e) => {
      const { name, value } = e.target;

      onChange({ [name]: value });

      // Track disposal question answers
      const questionLabelMap = {
        originalRc: 'RC Certificate',
        kycMatch: 'KYC Details',
        hypothecation: 'Hypothecation',
        criminalRecord: 'Criminal Record',
        pendingLiabilities: 'Pending Liabilities',
      };

      const eventAction = questionLabelMap[name] || name;

      pushToDataLayer({
        event: 'Enquiry_Form',
        eventCategory: 'Enquiry form',
        eventAction: eventAction,
        eventLabel: value === 'yes' ? 'Yes' : 'No',
        FormType: 'ELV Form',
        section_name: 'Disposal Details',
      });
    },
    [onChange, pushToDataLayer]
  );

  return (
    <form className="contact-form" onSubmit={onSubmit}>
      <div className="form-scroll">
        {disposalQuestions.map((item, index) => {
          const questionName = item?.fields?.Name?.value;
          const questionLabel = item?.fields?.Label?.value;

          if (!questionName) return null;

          return (
            <div key={item.id} className="form-group">
              <label className="disposal-question">
                {index + 1}. {questionLabel}
              </label>

              <div className="radio-group">
                {['yes', 'no'].map((value) => (
                  <label key={value} className="radio-option">
                    <input
                      type="radio"
                      name={questionName}
                      value={value}
                      checked={disposalData[questionName] === value}
                      onChange={handleChange}
                      required
                    />
                    <span>{value === 'yes' ? 'Yes' : 'No'}</span>
                  </label>
                ))}
              </div>
            </div>
          );
        })}
      </div>
      <div className="form-actions">
        <button type="button" className="button-secondary" onClick={onBack}>
          Back
        </button>
        <button type="submit" className="button-primary enabled">
          Next
        </button>
      </div>
    </form>
  );
};

export default DisposalForm;
